// extracted by mini-css-extract-plugin
export default {"uploadwidget":"UploadWidget_uploadwidget__pOj-D","uploadwidget__cover":"UploadWidget_uploadwidget__cover__f7QTT"};